import MediaViewerSmallViewPort from "./MediaViewerSmallViewPort";

export default MediaViewerSmallViewPort;
